/**
 * Modal — formulario de visita guiada (página Contacto).
 */
export function marianistaInitContactoVisitaModal() {
  const modal = document.getElementById('visitaModal');
  if (!modal) {
    return;
  }

  const closeBackdrop = document.getElementById('closeVisitaModal');
  const closeBtn = document.getElementById('closeVisitaModalBtn');
  const form = modal.querySelector('#visitaModalForm, form.wpcf7-form');
  const waBtn = document.getElementById('visitaModalWaBtn');

  const openModal = (event) => {
    if (event) {
      event.preventDefault();
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    const firstField = form?.querySelector('input, select, textarea');
    if (firstField instanceof HTMLElement) {
      window.setTimeout(() => firstField.focus(), 60);
    }
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  const triggerSelector = [
    '[data-open-visita-modal]',
    '#openVisitaModal',
    'a[href="#visitaModal"]',
    'a[href="#openVisitaModal"]',
  ].join(', ');

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest(triggerSelector)
      : null;
    if (!trigger) {
      return;
    }
    openModal(event);
  });

  closeBackdrop?.addEventListener('click', closeModal);
  closeBtn?.addEventListener('click', closeModal);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  function buildVisitaMessage() {
    if (!form) {
      return '';
    }
    const fd = new FormData(form);
    const get = (name) => (fd.get(name) || fd.get(name.replace(/_/g, '-')) || '').toString().trim();
    const nombre = get('padre_nombre') || get('padre-nombre');
    const tel = get('telefono');
    const correo = get('correo');
    const nivel = get('nivel');
    const fecha = get('fecha_preferida') || get('fecha-preferida');
    const mensaje = get('mensaje');

    const lines = [
      'Hola, quisiera agendar una visita guiada.',
      nombre ? `Nombre: ${nombre}` : '',
      tel ? `Teléfono: ${tel}` : '',
      correo ? `Correo: ${correo}` : '',
      nivel ? `Nivel de interés: ${nivel}` : '',
      fecha ? `Fecha preferida: ${fecha}` : '',
      mensaje ? `Mensaje: ${mensaje}` : '',
    ].filter(Boolean);

    return lines.join('\n');
  }

  if (form instanceof HTMLFormElement && form.id === 'visitaModalForm') {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
    });
  }

  waBtn?.addEventListener('click', () => {
    const base = (waBtn.getAttribute('data-wa-url') || '').trim();
    if (!base) {
      return;
    }
    const text = encodeURIComponent(buildVisitaMessage());
    const sep = base.includes('?') ? '&' : '?';
    window.open(`${base}${sep}text=${text}`, '_blank', 'noopener,noreferrer');
  });
}
